import React from 'react';
import {Tooltip, IconButton} from '@material-ui/core';
import {Button, NavigableSelectorDialog} from 'components/core';
import Image from 'material-ui-image';
import {HighlightOff, Add, LocationOn, AllOut} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { AnchorsCtx } from 'components/dataProviders/arAnchors';
import { LocationsCtx } from 'components/dataProviders/arLocations';

const style = makeStyles((theme) => ({
    item:
    {
        width: '100%',
        height: 56,
        backgroundColor: theme.palette.input.background,
        display: 'flex'
    },
    itemImageContainer:
    {
        flexBasis: 56,
    },
    itemMenu:
    {
        flexBasis: 56,
        padding: 4
    },
    itemText: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        padding: '10px 15px'
    },
    name: 
    {
        color: theme.palette.text.secondary,
        fontWeight: 500,
        float: 'left',
        width: '100%'
    },
    largeImg: {
        width: 500,
        height: 500,
        maxWidth: 500,
        padding: 0,
        borderRadius: 8,
        '& img':
        {
            borderRadius: 8
        }
    }
  }), {name: "RaymanARPoint"});

  function TooltipedPicture({item})
  {
    const classes = style();
    return <Tooltip placement="left" classes={{tooltip: classes.largeImg}} interactive
    title={
        <Image iconContainerStyle={{transform: 'scale(0.5)'}} color="transparent" src={item.pictureSrc} alt={item.name} className={classes.itemImage}/>
    }
  >
    <div className={classes.itemImageContainer}>
        <Image iconContainerStyle={{transform: 'scale(0.5)'}} color="transparent" src={item.pictureSrc} alt={item.name} className={classes.itemImage}/>
    </div>
    </Tooltip>
  }


function ARItem({item, editable, onRemove = null, ...props})
{
    const classes = style();

    const handleRemove = () => {
        if(onRemove) onRemove();
    }

    //if(!item) return null;

    return <div className={classes.item}>
        {item &&
            <TooltipedPicture item={item} />
        }
        <div className={classes.itemText}>
            <span className={classes.name}>{item ? item.name : "No se encuentra el punto AR"}</span>
        </div>
        
        {editable && 
            <div className={classes.itemMenu}>
                <IconButton onClick={handleRemove}>
                    <HighlightOff />
                </IconButton>
            </div>
        }
    </div>
}

function ARSelectorButton({onAdd = null})
{
    const [open, setOpen] = React.useState(false);
    const [items, setItems] = React.useState([]);

    const anchorsCtx = React.useContext(AnchorsCtx);
    const locationsCtx = React.useContext(LocationsCtx);

    React.useEffect(function InitializeItems()
    {
        let tmpItems = [];
        locationsCtx.data.array.forEach((location) => {
            let children = [];
            if(anchorsCtx.data.byLocation[location.locationID] !== undefined)
            {
                anchorsCtx.data.byLocation[location.locationID].forEach((anchor) =>
                {
                    children.push({
                        id: "a"+anchor.anchorID,
                        anchorID: anchor.anchorID,
                        name: anchor.name,
                        icon: <AllOut />,
                        picture: <TooltipedPicture item={anchor} />
                    });
                });
            }

            tmpItems.push({
                id: "l"+location.locationID,
                name: location.name,
                navigable: true,
                icon: <LocationOn />,
                children: children
            });
        });

        setItems(tmpItems);
    }, [anchorsCtx, locationsCtx]);

    function handleClose()
    {
        setOpen(false);
    }

    function handleOpen()
    {
        setOpen(true);
    }

    function handleConfirm(item)
    {
        onAdd(item.anchorID);
    }

    return <>
        <NavigableSelectorDialog items={items} onClose={handleClose} onConfirm={handleConfirm} open={open} />
        <Button fullWidth={false} color="primary" onClick={()=>handleOpen()}><Add />Asignar punto AR</Button>
        </>
}

function ARPoint({editable = false, anchorID = null, onRemove = null, onAdd = null})
{
    const anchorsCtx = React.useContext(AnchorsCtx);
    if(!editable && !anchorID) return null;

    if (editable && !anchorID) return <ARSelectorButton onAdd={onAdd} />
    else return <ARItem editable={editable} item={anchorsCtx.data.indexed[anchorID]} onRemove={onRemove} />
}

export default ARPoint;